(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7437],{

/***/ 14524:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/qna/realtime",
      function () {
        return __webpack_require__(64229);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);



var ArrowsButtonDownMin = function(param) {
    var _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.gray400 */ .Z.color.gray400 : _color, _size = param.size, size = _size === void 0 ? 16 : _size, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        style: style,
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.3594 5.40002L8.03125 8.8219L4.70312 5.40002L3.75 6.3219L8.03125 10.7281L12.3125 6.3219L11.3594 5.40002Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowsButtonDownMin);


/***/ }),

/***/ 72873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_AdExchangeComponent; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/common/ImpressionLoggerWithCallback.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ImpressionLoggerWithCallback = function(props) {
    var _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled, _once = props.once, once = _once === void 0 ? false : _once;
    var shouldLog = (0,react.useRef)(true);
    var itemRef = (0,react.useRef)(null);
    var setLoggingEnabled = function() {
        shouldLog.current = true;
    };
    var setLoggingDisabled = function() {
        shouldLog.current = false;
    };
    (0,react.useEffect)(function() {
        if (!enabled) {
            return;
        }
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) {
                    return;
                }
                if (!shouldLog.current) {
                    return;
                }
                if (once) {
                    setLoggingDisabled();
                }
                props.onImpressionLog();
            });
        });
        if (itemRef.current) {
            observer.observe(itemRef.current);
        }
        return function() {
            if (itemRef.current) {
                observer.unobserve(itemRef.current);
            }
        };
    }, [
        enabled,
        props.onImpressionLog
    ]);
    (0,react.useEffect)(function() {
        setLoggingEnabled();
        return function() {
            setLoggingDisabled();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        ref: itemRef,
        children: props.children
    });
};
/* harmony default export */ var common_ImpressionLoggerWithCallback = (ImpressionLoggerWithCallback);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e87b7643-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/hooks/auth/useAuth.ts
var useAuth = __webpack_require__(31310);
// EXTERNAL MODULE: ./src/hooks/useLogger.ts
var useLogger = __webpack_require__(8202);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ./src/components/atom/icon/SmallDelete.tsx
var SmallDelete = __webpack_require__(70691);
;// CONCATENATED MODULE: ./src/components/common/AdExchangeComponent.tsx








var ANIMATION_DURATION = 300;
var ANIMATION_DELAY = 50;
var AdExchangeContext = /*#__PURE__*/ (0,react.createContext)({
    bannerAdExchange: null,
    handleAdClick: function() {}
});
var useAdExchangeContext = function() {
    var context = (0,react.useContext)(AdExchangeContext);
    if (!context) {
        throw new Error("useAdExchangeContext must be used within AdExchangeComponent");
    }
    return context;
};
var isAnimationActive = false;
var AdExchangeComponent = function(props) {
    var logger = (0,useLogger/* default */.Z)();
    var isAnimationEnabled = function() {
        if (props.enableAnimation && isAnimationActive) {
            return true;
        }
        return !props.enableAnimation;
    };
    var ref = (0,react.useState)(function() {
        return isAnimationEnabled();
    }), isVisible = ref[0], setIsVisible = ref[1];
    (0,react.useEffect)(function() {
        if (props.enableAnimation && !isAnimationActive) {
            isAnimationActive = true;
        }
    }, [
        props.enableAnimation
    ]);
    (0,react.useEffect)(function() {
        if (props.enableAnimation && !isVisible) {
            var timer = setTimeout(function() {
                setIsVisible(true);
            }, ANIMATION_DELAY);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        props.enableAnimation
    ]);
    var handleAdClick = function(bannerAdExchange) {
        logger.log({
            eventName: "ad_banner_click",
            payload: {
                targetType: bannerAdExchange.targetPlace,
                bannerAdId: bannerAdExchange.bannerAdId,
                adViewerOsPlatform: bannerAdExchange.adViewerOsPlatform,
                exposedAt: Date.now().valueOf()
            }
        }, {
            datadogRum: false
        });
    };
    var getAnimationClasses = function() {
        if (!props.enableAnimation) return "w-full";
        return (0,style.cn)("w-full grid overflow-hidden", isVisible ? "[grid-template-rows:1fr]" : "[grid-template-rows:0fr]", "transition-[grid-template-rows] ease-in-out", "duration-[".concat(ANIMATION_DURATION, "ms]"));
    };
    if (!props.bannerAdExchange) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: getAnimationClasses(),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-h-0",
                children: props.fallback
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeContext.Provider, {
        value: {
            bannerAdExchange: props.bannerAdExchange,
            handleAdClick: handleAdClick
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: getAnimationClasses(),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-h-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ImpressionLoggerWithCallback, {
                    onImpressionLog: props.onImpressionLog,
                    children: props.children
                })
            })
        })
    });
};
/* harmony default export */ var common_AdExchangeComponent = (AdExchangeComponent);
var AdContent = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,style.cn)("flex w-full flex-col justify-center gap-[8px]", className),
        children: children
    });
};
var BandCta = function(param) {
    var className = param.className, onClose = param.onClose;
    var token = (0,useAuth/* default */.Z)().token;
    var ref = useAdExchangeContext(), bannerAdExchange = ref.bannerAdExchange, handleAdClick = ref.handleAdClick;
    if (!bannerAdExchange) {
        return null;
    }
    var handleActionClick = function() {
        bannerAdExchange.action(token, handleAdClick);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,style.cn)("flex w-full items-center justify-between bg-gray-700", "pt-[12px] pr-[20px] pb-[12px] pl-[12px]", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-[12px]",
                children: [
                    onClose && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: onClose,
                        "aria-label": "광고 닫기",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallDelete/* default */.Z, {
                            color: theme/* default.color.gray300 */.Z.color.gray300,
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-13m text-white",
                                children: bannerAdExchange.subTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-15sb text-white",
                                children: bannerAdExchange.title
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "typography-ui-13m h-[32px] rounded-lg border bg-primary-600 px-[8px] text-white",
                    onClick: handleActionClick,
                    children: bannerAdExchange.buttonLabel
                })
            })
        ]
    });
};
var ImageAd = function(param) {
    var className = param.className, isShowAdBadge = param.isShowAdBadge;
    var token = (0,useAuth/* default */.Z)().token;
    var ref = useAdExchangeContext(), bannerAdExchange = ref.bannerAdExchange, handleAdClick = ref.handleAdClick;
    if (!(bannerAdExchange === null || bannerAdExchange === void 0 ? void 0 : bannerAdExchange.bannerImageUrl)) {
        return null;
    }
    var handleImageClick = function() {
        bannerAdExchange.action(token, handleAdClick);
    };
    var altText = bannerAdExchange.title || bannerAdExchange.deliberatedCode || "광고 이미지";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                onClick: handleImageClick,
                className: (0,style.cn)("cursor-pointer object-contain", className),
                src: bannerAdExchange.bannerImageUrl,
                alt: altText
            }),
            isShowAdBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute right-[8px] bottom-[8px] flex h-[20px] w-[32px] items-center justify-center rounded-[6px] bg-dimmed-40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "typography-ui-12m text-white",
                    children: "AD"
                })
            })
        ]
    });
};
AdExchangeComponent.ImageAd = ImageAd;
AdExchangeComponent.Content = AdContent;
AdExchangeComponent.BandCta = BandCta;


/***/ }),

/***/ 40906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_PaginationComponent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/lucide-react/dist/esm/icons/ellipsis.js
var ellipsis = __webpack_require__(60301);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ../../node_modules/class-variance-authority/dist/index.mjs
var dist = __webpack_require__(10929);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/dnDesignSystem/components/ui/pagination.tsx











var paginationVariants = (0,dist/* cva */.j)("typography-ui-17sb flex items-center justify-center", {
    variants: {
        variant: {
            disabled: "rounded-[50%] bg-white",
            default: "rounded-[50%] bg-white text-gray-500 hover:bg-gray-50",
            active: "rounded-[50%] bg-primary-600 text-white"
        },
        size: {
            default: "h-[32px] min-w-[32px] px-[2px]",
            icon: "h-[28px] min-w-[28px] px-[2px]"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
var Pagination = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("nav", (0,_object_spread/* default */.Z)({
        role: "navigation",
        "aria-label": "pagination",
        className: (0,style.cn)("mx-auto mt-[20px] flex w-full justify-center", className)
    }, props));
};
Pagination.displayName = "Pagination";
var PaginationContent = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("ul", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,style.cn)("flex flex-row items-center gap-[4px]", className)
    }, props));
});
PaginationContent.displayName = "PaginationContent";
var PaginationItem = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("li", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,style.cn)("", className)
    }, props));
});
PaginationItem.displayName = "PaginationItem";
var PaginationLink = function(_param) {
    var className = _param.className, isActive = _param.isActive, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _size = _param.size, size = _size === void 0 ? "default" : _size, href = _param.href, _scroll = _param.scroll, scroll = _scroll === void 0 ? true : _scroll, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "isActive",
        "variant",
        "size",
        "href",
        "scroll"
    ]);
    var disabled = variant === "disabled";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-current": isActive ? "page" : undefined,
        href: href,
        scroll: scroll
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "aria-disabled": disabled,
            tabIndex: disabled ? -1 : undefined,
            className: (0,style.cn)(paginationVariants({
                variant: variant,
                size: size
            }), className, disabled ? "pointer-events-none" : ""),
            children: props.children
        })
    }));
};
PaginationLink.displayName = "PaginationLink";
var PaginationPrevious = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to previous page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_arrow_left",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationPrevious.displayName = "PaginationPrevious";
var PaginationDoublePrevious = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to double previous page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_double_arrow_left",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationDoublePrevious.displayName = "PaginationDoublePrevious";
var PaginationNext = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to next page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_arrow_right",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationNext.displayName = "PaginationNext";
var PaginationDoubleNext = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to double next page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_double_arrow_right",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationDoubleNext.displayName = "PaginationDoubleNext";
var PaginationEllipsis = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsxs)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-hidden": true,
        className: (0,style.cn)("flex h-9 w-9 items-center justify-center", className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ellipsis/* default */.Z, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "More pages"
            })
        ]
    }));
};
PaginationEllipsis.displayName = "PaginationEllipsis";


;// CONCATENATED MODULE: ./src/hooks/common/usePagination.ts

var PaginationType;
(function(PaginationType) {
    PaginationType["DOUBLE_PREVIOUS"] = "DOUBLE_PREVIOUS";
    PaginationType["PREVIOUS"] = "PREVIOUS";
    PaginationType["NEXT"] = "NEXT";
    PaginationType["DOUBLE_NEXT"] = "DOUBLE_NEXT";
    PaginationType["LINK"] = "LINK";
})(PaginationType || (PaginationType = {}));
var getPageInfos = function(page, totalPage, perPage) {
    var pageInfo = [];
    var halfPerPage = Math.floor(perPage / 2);
    var startPage = page - halfPerPage;
    var endPage = page + halfPerPage;
    if (startPage < 1) {
        startPage = 1;
        endPage = Math.min(perPage, totalPage);
    } else if (endPage > totalPage) {
        endPage = totalPage;
        startPage = Math.max(1, totalPage - perPage + 1);
    }
    var doublePreviousPage = Math.max(1, page - perPage);
    pageInfo.push({
        type: PaginationType.DOUBLE_PREVIOUS,
        page: doublePreviousPage,
        isActive: page > 1
    });
    var previousPage = Math.max(1, page - 1);
    pageInfo.push({
        type: PaginationType.PREVIOUS,
        page: previousPage,
        isActive: page > 1
    });
    for(var i = startPage; i <= endPage; i++){
        pageInfo.push({
            type: PaginationType.LINK,
            page: i,
            isActive: i === page
        });
    }
    var nextPage = Math.min(totalPage, page + 1);
    pageInfo.push({
        type: PaginationType.NEXT,
        page: nextPage,
        isActive: page < totalPage
    });
    var doubleNextPage = Math.min(totalPage, page + perPage);
    pageInfo.push({
        type: PaginationType.DOUBLE_NEXT,
        page: doubleNextPage,
        isActive: page < totalPage
    });
    return pageInfo;
};
var usePagination = function(page, totalPage) {
    var perPage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    var ref = (0,react.useState)(function() {
        return getPageInfos(page, totalPage, perPage);
    }), pageInfos = ref[0], setPageInfos = ref[1];
    (0,react.useEffect)(function() {
        setPageInfos(getPageInfos(page, totalPage, perPage));
    }, [
        page,
        totalPage,
        perPage
    ]);
    return pageInfos;
};
/* harmony default export */ var common_usePagination = (usePagination);

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/hooks/useScrollRestoration.ts


var useScrollRestoration = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        ref: undefined,
        enabled: true
    }, ref1 = ref.ref, _enabled = ref.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var router = (0,next_router.useRouter)();
    var isPopStateRef = (0,react.useRef)(false);
    var pendingScrollRef = (0,react.useRef)(null);
    var scrollKey = function(path) {
        return "scrollPos_".concat(path);
    };
    var saveScrollPos = function(path) {
        var scrollPos = (ref1 === null || ref1 === void 0 ? void 0 : ref1.current) ? {
            x: ref1.current.scrollLeft,
            y: ref1.current.scrollTop
        } : {
            x: window.scrollX,
            y: window.scrollY
        };
        sessionStorage.setItem(path, JSON.stringify(scrollPos));
    };
    var getSavedScrollPos = function(path) {
        var savedPos = sessionStorage.getItem(path);
        if (!savedPos) return null;
        return JSON.parse(savedPos);
    };
    var applyScrollPosition = function(x, y) {
        var targetElement = (ref1 === null || ref1 === void 0 ? void 0 : ref1.current) || window;
        requestAnimationFrame(function() {
            targetElement.scrollTo(x, y);
        });
    };
    (0,react.useLayoutEffect)(function() {
        if (enabled && pendingScrollRef.current) {
            var _current = pendingScrollRef.current, x = _current.x, y = _current.y;
            applyScrollPosition(x, y);
            pendingScrollRef.current = null;
        }
    });
    (0,react.useLayoutEffect)(function() {
        if (!enabled) return;
        if (!("scrollRestoration" in window.history)) return;
        window.history.scrollRestoration = "manual";
        var currentPath = scrollKey(router.asPath);
        var onRouteChangeStart = function() {
            if (!isPopStateRef.current) {
                saveScrollPos(currentPath);
            }
        };
        var onRouteChangeComplete = function() {
            var newPath = scrollKey(router.asPath);
            if (isPopStateRef.current) {
                var savedPos = getSavedScrollPos(newPath);
                if (savedPos) {
                    pendingScrollRef.current = savedPos;
                }
                isPopStateRef.current = false;
            } else {
                pendingScrollRef.current = {
                    x: 0,
                    y: 0
                };
            }
        };
        router.beforePopState(function() {
            isPopStateRef.current = true;
            return true;
        });
        router.events.on("routeChangeStart", onRouteChangeStart);
        router.events.on("routeChangeComplete", onRouteChangeComplete);
        return function() {
            router.events.off("routeChangeStart", onRouteChangeStart);
            router.events.off("routeChangeComplete", onRouteChangeComplete);
        };
    }, [
        ref1,
        router.asPath,
        enabled
    ]);
};

// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/components/common/PaginationComponent.tsx








var PaginationComponent = function(props) {
    var queries = props.queries, baseUrl = props.baseUrl, _pageKeyName = props.pageKeyName, pageKeyName = _pageKeyName === void 0 ? "page" : _pageKeyName, _scroll = props.scroll, scroll = _scroll === void 0 ? true : _scroll, _scrollRestoration = props.scrollRestoration, scrollRestoration = _scrollRestoration === void 0 ? true : _scrollRestoration, _perPage = props.perPage, perPage = _perPage === void 0 ? 5 : _perPage, totalPage = props.totalPage, currentPage = props.currentPage;
    var pageInfos = common_usePagination(currentPage, totalPage, perPage);
    useScrollRestoration({
        ref: undefined,
        enabled: scrollRestoration
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationContent, {
            children: pageInfos.map(function(pageInfo) {
                switch(pageInfo.type){
                    case PaginationType.DOUBLE_PREVIOUS:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationDoublePrevious, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                    case PaginationType.PREVIOUS:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationPrevious, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                    case PaginationType.LINK:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationLink, {
                                isActive: pageInfo.isActive,
                                variant: pageInfo.isActive ? "active" : "default",
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page))),
                                children: pageInfo.page
                            })
                        }, "pagination-".concat(pageInfo.type, "-").concat(pageInfo.page));
                    case PaginationType.NEXT:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationNext, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                    case PaginationType.DOUBLE_NEXT:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationDoubleNext, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                }
            })
        })
    });
};
/* harmony default export */ var common_PaginationComponent = (PaginationComponent);


/***/ }),

/***/ 80138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_atom_Tab_LineTab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11466);
/* harmony import */ var _components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39535);





var CategoryBottomSheet = function(param) {
    var isVisible = param.isVisible, categoryGroup = param.categoryGroup, selectedTab = param.selectedTab, onClickCategoriesBottomSheetTab = param.onClickCategoriesBottomSheetTab, toggleBottomSheet = param.toggleBottomSheet, onClickCategoryItem = param.onClickCategoryItem, getSelectedTabItemList = param.getSelectedTabItemList;
    if (!categoryGroup) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        index: 10,
        isOpened: isVisible,
        onClickOverlay: function() {
            return toggleBottomSheet(false);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Tabs */ .ZP.Tabs, {
            tabs: categoryGroup.tabs,
            selectedTab: selectedTab,
            activeColor: _components_atom_Tab_LineTab__WEBPACK_IMPORTED_MODULE_1__/* .LINE_TAB_COLOR.BLACK */ .r.BLACK,
            inActiveColor: _components_atom_Tab_LineTab__WEBPACK_IMPORTED_MODULE_1__/* .LINE_TAB_COLOR.GREY */ .r.GREY,
            onClickTab: function(tab) {
                return onClickCategoriesBottomSheetTab((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, tab), {
                    value: tab.value
                }));
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Tabs.List */ .ZP.Tabs.List, {
                items: getSelectedTabItemList(),
                onClickItem: onClickCategoryItem
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryBottomSheet);


/***/ }),

/***/ 37083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_QuestionList; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/molecules/Loader/index.tsx + 1 modules
var Loader = __webpack_require__(6505);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.tsx
var useIntersectionObserver = __webpack_require__(13041);
;// CONCATENATED MODULE: ./src/components/molecules/InfiniteScroll/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: scroll;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var InfiniteScroll = function(param) {
    var _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, rootMargin = param.rootMargin, children = param.children, _loader = param.loader, loader = _loader === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : _loader, isLoading = param.isLoading, hasNextPage = param.hasNextPage, fetchNextPage = param.fetchNextPage;
    var ref = (0,react.useState)(), loaderElement = ref[0], setLoaderElement = ref[1];
    var entry = (0,useIntersectionObserver/* default */.Z)({
        target: loaderElement,
        threshold: threshold,
        rootMargin: rootMargin
    });
    (0,react.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && hasNextPage && !isLoading) {
            fetchNextPage();
        }
    }, [
        entry,
        hasNextPage,
        isLoading,
        fetchNextPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfiniteScrollContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            }),
            hasNextPage && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: function(ref) {
                    return setLoaderElement(ref);
                },
                children: loader
            })
        ]
    });
};
/* harmony default export */ var molecules_InfiniteScroll = (InfiniteScroll);
var InfiniteScrollContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-690005ef-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/components/molecules/ScrollTopStickyButton/index.tsx + 1 modules
var ScrollTopStickyButton = __webpack_require__(79771);
// EXTERNAL MODULE: ./src/components/molecules/QuestionList/QuestionItem/index.tsx + 1 modules
var QuestionItem = __webpack_require__(38427);
// EXTERNAL MODULE: ./src/components/molecules/QuestionList/QuestionItem/EmptyQuestionList/index.tsx + 1 modules
var EmptyQuestionList = __webpack_require__(49839);
// EXTERNAL MODULE: ./src/components/molecules/QuestionList/QuestionsSkeleton.tsx
var QuestionsSkeleton = __webpack_require__(19278);
;// CONCATENATED MODULE: ./src/components/molecules/QuestionList/index.tsx






var QuestionList = function(param) {
    var questionCard = param.questionCard, emptyMessage = param.emptyMessage, _bottomButtonType = param.bottomButtonType, bottomButtonType = _bottomButtonType === void 0 ? EmptyQuestionList/* EMPTY_QUESTIONS_BOTTOM_BUTTON_TYPE.WRITE */.y.WRITE : _bottomButtonType, pageName = param.pageName, emptyComponent = param.emptyComponent, onClickQuestion = param.onClickQuestion;
    var ref, ref1;
    if (questionCard.isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionsSkeleton/* default */.Z, {});
    }
    if (!questionCard.isLoading && !((ref = questionCard.data) === null || ref === void 0 ? void 0 : ref.length)) {
        if (emptyComponent) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: emptyComponent
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyQuestionList/* default */.Z, {
            message: emptyMessage !== null && emptyMessage !== void 0 ? emptyMessage : {
                title: "등록된 질문이 없어요",
                description: "첫 질문을 남겨보세요."
            },
            bottomButtonType: bottomButtonType,
            pageName: pageName
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_InfiniteScroll, {
                rootMargin: "0px 0px 0px 100px",
                isLoading: questionCard.isLoading,
                hasNextPage: questionCard.hasNextPage,
                fetchNextPage: questionCard.fetchNextPage,
                children: (ref1 = questionCard.data) === null || ref1 === void 0 ? void 0 : ref1.map(function(question) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionItem/* default */.Z, {
                        isPaidQuestion: Boolean(question.paymentTotal),
                        questionCard: question,
                        onClickQuestion: onClickQuestion
                    }, question.question.questionPid);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopStickyButton/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var molecules_QuestionList = (QuestionList);


/***/ }),

/***/ 79125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_atom_icon_SmallDelete__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70691);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);
/* harmony import */ var _utils_airbridge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);






var AppInstallTopBanner = function(param) {
    var onClickClose = param.onClickClose, content = param.content, trackingInfo = param.trackingInfo, onLogEvent = param.onLogEvent;
    var ref = trackingInfo !== null && trackingInfo !== void 0 ? trackingInfo : {}, contentCategory = ref.contentCategory, contentId = ref.contentId, contentTitle = ref.contentTitle, campaign = ref.campaign, contentSubCategory = ref.contentSubCategory;
    var onClickInstallApp = function() {
        onLogEvent === null || onLogEvent === void 0 ? void 0 : onLogEvent();
        _utils_airbridge__WEBPACK_IMPORTED_MODULE_3__/* ["default"].setDynamicLink */ .Z.setDynamicLink((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            campaign: campaign,
            content: content,
            term: "앱 열기",
            sub_id: contentId,
            sub_id_1: contentTitle,
            sub_id_2: contentCategory
        }, contentSubCategory && {
            sub_id_3: contentSubCategory
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sticky top-[60px] z-[300] flex w-full items-center justify-between bg-gray-700 pt-[14px] pr-[20px] pb-[12px] pl-[12px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: onClickClose,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_SmallDelete__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            color: _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.gray300 */ .Z.color.gray300,
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "typography-ui-13m text-white",
                                children: "병원 문 닫은 늦은 밤, 주말에도"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "typography-ui-15sb text-white",
                                children: "닥터나우는 24시간 열려있어요!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "typography-ui-13m h-[32px] rounded-lg border bg-primary-600 px-[8px] text-white",
                    onClick: onClickInstallApp,
                    children: "바로 진료받기"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppInstallTopBanner);


/***/ }),

/***/ 6191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ MODAL_SHOW_PAGES; },
  "Z": function() { return /* binding */ Cuj_useAppDownloadCujModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/recoil/atoms/cuj/index.ts
var cuj = __webpack_require__(15951);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/components/common/Modal/Cuj/AppDownloadCujModal.tsx






var AppDownloadCujModal = function() {
    var router = (0,next_router.useRouter)();
    var handleAppDownload = Cuj_useAppDownloadCujModal().handleAppDownload;
    var onClickAppDownload = function() {
        (0,logger/* logger */.kg)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: "app_download_modal_click"
        });
        (0,cuj/* setAppDownloadCujModalState */.Ih)({
            isShow: false
        });
        handleAppDownload("지금 앱으로 진료받기");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-10 flex w-full flex-col items-center gap-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-1 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "typography-ui-19sb text-white",
                        children: "대한민국 1위 비대면 진료 앱 닥터나우"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "typography-ui-28b flex flex-col items-center text-primary-700",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "늦은 밤, 주말에도"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "진료 가능해요"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[188px] overflow-hidden rounded-t-[20px] bg-gray-30 p-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "w-full rounded-lg",
                            src: "/images/qna/appHomeScreen.png",
                            alt: "app_home_screen"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "typography-ui-17sb h-14 w-60 rounded-xl bg-primary-600 text-white",
                        type: "button",
                        onClick: onClickAppDownload,
                        children: "지금 앱으로 진료받기"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Cuj_AppDownloadCujModal = (AppDownloadCujModal);

// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
;// CONCATENATED MODULE: ./src/hooks/Cuj/useAppDownloadCujModal.tsx












var MODAL_SHOW_PAGES = [
    {
        path: "/",
        link: "https://abr.ge/fgbb8h"
    },
    {
        path: "/content/qna/realtime",
        link: "https://abr.ge/xl6mno"
    },
    {
        path: "/content/qna/[id]",
        link: "https://abr.ge/y2mlu1"
    },
    {
        path: "/hospitals",
        link: "https://abr.ge/1totxt"
    },
    {
        path: "/hospitals/search",
        link: "https://abr.ge/a1rxxv"
    },
    {
        path: "/hospitals/[hospitalPid]",
        link: "https://abr.ge/cmgskv"
    },
    {
        path: "/content/magazine",
        link: "https://abr.ge/dt8fv1"
    },
    {
        path: "/content/magazine/[id]",
        link: "https://abr.ge/054rrl"
    },
    {
        path: "/content/faq/[id]",
        link: "https://abr.ge/rgoppq"
    },
    {
        path: "/search",
        link: "https://abr.ge/yurdtxu"
    },
    {
        path: "/content/qna/ai-answer/[pid]",
        link: "https://abr.ge/mwmjor"
    }, 
];
var useAppDownloadCujModal = function() {
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), _isShow = ref1[0], _setIsShow = ref1[1];
    var appDownloadCujModal = (0,es.useRecoilValue)(cuj/* appDownloadCujModalState */.Ze);
    var modalShowPaths = MODAL_SHOW_PAGES.reduce(function(acc, cur) {
        return (0,_to_consumable_array/* default */.Z)(acc).concat([
            cur.path
        ]);
    }, []);
    var isShowPath = modalShowPaths.includes(router.pathname);
    (0,react.useEffect)(function() {
        if (_isShow && isShowPath && appDownloadCujModal && appDownloadCujModal.isShow) {
            showModal({
                type: modal/* MODAL_TYPE.CUSTOM_BACKGROUND */.f.CUSTOM_BACKGROUND,
                props: {
                    body: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cuj_AppDownloadCujModal, {}),
                    backgroundColor: theme/* default.color.dimmed80 */.Z.color.dimmed80,
                    onClickOverlay: function() {
                        closeModal();
                    }
                }
            });
        }
    }, [
        _isShow,
        isShowPath,
        appDownloadCujModal.isShow
    ]);
    (0,react.useEffect)(function() {
        var close = function() {
            closeModal();
        };
        window.addEventListener("popstate", close);
        return function() {
            window.removeEventListener("popstate", close);
        };
    });
    var setIsCujModalTrackingInfo = function(params) {
        (0,cuj/* setAppDownloadCujModalState */.Ih)({
            campaignName: params.campaignName,
            trackContent: params.trackContent,
            contentId: params.contentId,
            contentTitle: params.contentTitle,
            contentCategory: params.contentCategory,
            contentSubCategory: params.contentSubCategory
        });
    };
    var handleAppDownload = function(buttonText) {
        airbridge/* default.setDynamicLink */.Z.setDynamicLink((0,_object_spread/* default */.Z)({
            campaign: appDownloadCujModal.campaignName || "unknown",
            content: appDownloadCujModal.trackContent,
            term: buttonText,
            sub_id: appDownloadCujModal.contentId,
            sub_id_1: appDownloadCujModal.contentTitle,
            sub_id_2: appDownloadCujModal.contentCategory
        }, appDownloadCujModal.contentSubCategory && {
            sub_id_3: appDownloadCujModal.contentSubCategory
        }));
    };
    return {
        setIsCujModalShow: _setIsShow,
        setIsCujModalTrackingInfo: setIsCujModalTrackingInfo,
        handleAppDownload: handleAppDownload
    };
};
/* harmony default export */ var Cuj_useAppDownloadCujModal = (useAppDownloadCujModal);


/***/ }),

/***/ 72105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _models_ad_list__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70847);
/* harmony import */ var _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53476);
/* harmony import */ var _ad_useAdBanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28844);





var useAppInstallTopBanner = function(client) {
    var isVisible = (0,recoil__WEBPACK_IMPORTED_MODULE_3__.useRecoilValue)(_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__/* .appInstallTopBannerState */ .Ep).isVisible;
    var ref = (0,_ad_useAdBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_models_ad_list__WEBPACK_IMPORTED_MODULE_0__/* .AdPageType.TopCtaBand */ .hO.TopCtaBand, client, true), bannerAdExchange = ref.bannerAdExchange, handleSendExposureLog = ref.handleSendExposureLog;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__/* .getAppInstallTopBannerState */ ._l)();
    }, []);
    return {
        bannerAdExchange: bannerAdExchange,
        handleSendExposureLog: handleSendExposureLog,
        isVisible: isVisible,
        hideBanner: _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__/* .hideBanner */ .dl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppInstallTopBanner);


/***/ }),

/***/ 31310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4415);


var useAuth = function() {
    var token = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilValue)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_1__/* .tokenState */ .J1);
    return {
        token: token
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 62139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var _mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4365);



var parseQnaCategoryGroup = function(data) {
    var categoryGroups = data.questionCategoryGroups;
    var parsedCategories = function() {
        return categoryGroups.map(function(questionCategory) {
            return {
                key: questionCategory.key,
                name: questionCategory.name,
                categories: questionCategory.questionCategories.map(function(category) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, category), {
                        key: questionCategory.key,
                        title: category.name,
                        content: category.description,
                        iconImageUrl: category.iconImageUrl,
                        value: category.questionCategoryId,
                        checked: false
                    });
                })
            };
        });
    };
    return {
        tabs: categoryGroups.map(function(category) {
            var key = category.key, name = category.name;
            return {
                key: key,
                label: name,
                value: key
            };
        }),
        tabsList: parsedCategories(),
        categories: parsedCategories().reduce(function(acc, cur) {
            return acc.concat(cur.categories);
        }, [])
    };
};
var useGetQnaCategoryGroup = function() {
    var ref = (0,_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useGetQnaCategoryGroupQuery */ .Tb)({}, {
        select: parseQnaCategoryGroup
    }), categoryGroup = ref.data;
    return {
        categoryGroup: categoryGroup
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetQnaCategoryGroup);


/***/ }),

/***/ 13041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87394);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var useIntersectionObserver = function(param) {
    var target = param.target, _freeze = param.freeze, freeze = _freeze === void 0 ? false : _freeze, _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, _root = param.root, root = _root === void 0 ? null : _root, _rootMargin = param.rootMargin, rootMargin = _rootMargin === void 0 ? "0%" : _rootMargin;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), entry = ref[0], setEntry = ref[1];
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var updateEntry = function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), currentEntry = _param[0];
        setEntry(currentEntry);
    };
    var cleanObserver = function() {
        if (observer.current) {
            observer.current.disconnect();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var hasIOSupport = "IntersectionObserver" in window;
        if (!freeze && target && hasIOSupport) {
            var observerParams = {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            };
            var observer = new IntersectionObserver(updateEntry, observerParams);
            observer.observe(target);
        }
        return function() {
            cleanObserver();
        };
    }, [
        target,
        root,
        rootMargin,
        threshold,
        freeze
    ]);
    return entry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersectionObserver);


/***/ }),

/***/ 64229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ realtime; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/atom/icon/ArrowsButtonDownMin.tsx
var ArrowsButtonDownMin = __webpack_require__(92803);
// EXTERNAL MODULE: ./src/components/common/QnaStickyWriteButton/index.tsx + 1 modules
var QnaStickyWriteButton = __webpack_require__(84963);
// EXTERNAL MODULE: ./src/components/common/communication/qna/CategoryBottomSheet.tsx
var CategoryBottomSheet = __webpack_require__(80138);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/StickyAppHeader/index.tsx + 3 modules
var StickyAppHeader = __webpack_require__(73487);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Common/BoardTemplate/QnaHome/AiNotificationBanner/index.tsx + 1 modules
var AiNotificationBanner = __webpack_require__(74063);
// EXTERNAL MODULE: ./src/hooks/useScreenFocus.tsx
var useScreenFocus = __webpack_require__(50341);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
// EXTERNAL MODULE: ./src/components/common/AdExchangeComponent.tsx + 1 modules
var AdExchangeComponent = __webpack_require__(72873);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Common/AppInstallTopBanner.tsx
var AppInstallTopBanner = __webpack_require__(79125);
// EXTERNAL MODULE: ./src/features/paid-question-termination/index.ts + 3 modules
var paid_question_termination = __webpack_require__(45696);
// EXTERNAL MODULE: ./src/features/paid-question-termination/ui/PaidQuestionTerminationNoticeModal.tsx
var PaidQuestionTerminationNoticeModal = __webpack_require__(67426);
// EXTERNAL MODULE: ./src/components/common/PaginationComponent.tsx + 3 modules
var PaginationComponent = __webpack_require__(40906);
// EXTERNAL MODULE: ./src/components/molecules/QuestionList/QuestionItem/index.tsx + 1 modules
var QuestionItem = __webpack_require__(38427);
// EXTERNAL MODULE: ./src/components/molecules/QuestionList/QuestionsSkeleton.tsx
var QuestionsSkeleton = __webpack_require__(19278);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/entities/qna/hook/qna.gql.impl.tsx


var SearchQuestionsItemsDocument = "\n    query SearchQuestionsItems($request: QuestionSearchRequestInput!) {\n  searchQuestions(request: $request) {\n    items {\n      status\n      accessibleType\n      attachments {\n        blindType\n        id\n      }\n      category {\n        name\n        id\n        iconImagePath\n      }\n      tags {\n        name\n      }\n      createdAt\n      content\n      isBlockedByMe\n      publicId\n      title\n      userMaskedName\n      userId\n    }\n  }\n}\n    ";
var useSearchQuestionsItemsQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "SearchQuestionsItems",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(SearchQuestionsItemsDocument, "SearchQuestionsItems", variables), options);
};
useSearchQuestionsItemsQuery.getKey = function(variables) {
    return [
        "SearchQuestionsItems",
        variables
    ];
};
useSearchQuestionsItemsQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(SearchQuestionsItemsDocument, "SearchQuestionsItems", variables, options);
};
var SearchQuestionsTotalCountDocument = "\n    query SearchQuestionsTotalCount($request: QuestionSearchRequestInput!) {\n  searchQuestions(request: $request) {\n    totalCount\n  }\n}\n    ";
var useSearchQuestionsTotalCountQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "SearchQuestionsTotalCount",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(SearchQuestionsTotalCountDocument, "SearchQuestionsTotalCount", variables), options);
};
useSearchQuestionsTotalCountQuery.getKey = function(variables) {
    return [
        "SearchQuestionsTotalCount",
        variables
    ];
};
useSearchQuestionsTotalCountQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(SearchQuestionsTotalCountDocument, "SearchQuestionsTotalCount", variables, options);
};

;// CONCATENATED MODULE: ./src/entities/qna/hook/useSearchQuestions.ts







var DEFAULT_SIZE = 20;
var parseRealtimeQnaCardVo = function(data) {
    var items = data.searchQuestions.items.map(function(item) {
        var _title;
        return {
            answeredStatus: gql_schema/* QuestionAnsweredStatus.Answered */.G26.Answered,
            answer: null,
            answererCount: 0,
            answererProfileImageUrls: [],
            question: {
                accessibleType: item.accessibleType,
                content: item.content,
                createdAt: item.createdAt,
                isBlockedByMe: item.isBlockedByMe,
                isLikedByMe: false,
                isMine: false,
                likeCount: 0,
                questionPid: item.publicId,
                title: (_title = item.title) !== null && _title !== void 0 ? _title : "",
                attachments: (0,format/* sortImageBlindTypeFormat */.zV)(item.attachments.map(function(attachment) {
                    return {
                        blindType: attachment.blindType,
                        questionAttachmentId: attachment.id
                    };
                })),
                category: {
                    name: item.category.name,
                    questionCategoryId: item.category.id,
                    iconImageUrl: item.category.iconImagePath
                },
                tags: item.tags,
                user: {
                    name: item.userMaskedName,
                    userId: item.userId
                }
            },
            questionCreatedAt: (0,format/* absoluteDate */.xt)(item.createdAt),
            answerCreatedAt: null,
            answeredStatusText: ""
        };
    });
    return items;
};
var parseRealtimeQnaCardTotalCount = function(data) {
    return data.searchQuestions.totalCount;
};
var useSearchQuestions = function(param) {
    var categoryIds = param.categoryIds, _page = param.page, page = _page === void 0 ? 1 : _page, _size = param.size, size = _size === void 0 ? DEFAULT_SIZE : _size;
    var request = {
        categoryIds: categoryIds,
        page: page,
        size: size,
        sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
    };
    var ref = useSearchQuestionsTotalCountQuery({
        request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, request), {
            page: 1
        })
    }, {
        staleTime: 5000,
        cacheTime: 5000,
        select: parseRealtimeQnaCardTotalCount
    }), tmp = ref.data, totalCount = tmp === void 0 ? 0 : tmp, isLoadingTotalCount = ref.isLoading;
    var ref1 = useSearchQuestionsItemsQuery({
        request: request
    }, {
        select: parseRealtimeQnaCardVo
    }), tmp1 = ref1.data, questions = tmp1 === void 0 ? [] : tmp1, isLoading = ref1.isLoading;
    var totalPage = Math.ceil(totalCount / size);
    return {
        totalCount: totalCount,
        totalPage: totalPage,
        isLoading: isLoadingTotalCount || isLoading,
        questions: questions
    };
};
/* harmony default export */ var hook_useSearchQuestions = (useSearchQuestions);
useSearchQuestions.prefetchTotalCountQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, variables) {
        var _size, request;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = {
                        categoryIds: variables.categoryIds,
                        page: 1,
                        size: (_size = variables.size) !== null && _size !== void 0 ? _size : DEFAULT_SIZE,
                        sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
                    };
                    return [
                        4,
                        queryClient.prefetchQuery({
                            queryKey: useSearchQuestionsTotalCountQuery.getKey({
                                request: request
                            }),
                            queryFn: function() {
                                return useSearchQuestionsTotalCountQuery.fetcher({
                                    request: request
                                })();
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, variables) {
        return _ref.apply(this, arguments);
    };
}();
useSearchQuestions.prefetchItemsQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, variables) {
        var _page, _size, request;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = {
                        categoryIds: variables.categoryIds,
                        page: (_page = variables.page) !== null && _page !== void 0 ? _page : 1,
                        size: (_size = variables.size) !== null && _size !== void 0 ? _size : DEFAULT_SIZE,
                        sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
                    };
                    return [
                        4,
                        queryClient.prefetchQuery({
                            queryKey: useSearchQuestionsItemsQuery.getKey({
                                request: request
                            }),
                            queryFn: function() {
                                return useSearchQuestionsItemsQuery.fetcher({
                                    request: request
                                })();
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, variables) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
;// CONCATENATED MODULE: ./src/features/qna/realtime-web/viewModels/useRealtimeWebQnaViewModel.ts



var useRealtimeWebQnaViewModel_DEFAULT_SIZE = 20;
var useRealtimeWebQnaViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var _query = router.query, _categoryId = _query.categoryId, categoryId = _categoryId === void 0 ? "" : _categoryId, _page = _query.page, page = _page === void 0 ? "1" : _page;
    var selectedCategoryIds = (0,react.useMemo)(function() {
        return categoryId ? [
            categoryId
        ] : [];
    }, [
        categoryId
    ]);
    var ref = hook_useSearchQuestions({
        categoryIds: selectedCategoryIds,
        page: Number(page),
        size: useRealtimeWebQnaViewModel_DEFAULT_SIZE
    }), questions = ref.questions, isQnaListLoading = ref.isLoading, totalPage = ref.totalPage;
    return {
        queries: {
            categoryId: categoryId,
            page: page
        },
        questions: questions,
        isQnaListLoading: isQnaListLoading,
        totalPage: totalPage
    };
};
/* harmony default export */ var viewModels_useRealtimeWebQnaViewModel = (useRealtimeWebQnaViewModel);

;// CONCATENATED MODULE: ./src/features/qna/realtime-web/ui/RealtimeWebQna.tsx







var RealtimeWebQna = function() {
    var viewModel = viewModels_useRealtimeWebQnaViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            viewModel.isQnaListLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionsSkeleton/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: viewModel.questions.map(function(qna) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(qna.question.questionPid),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionItem/* default */.Z, {
                                    questionCard: qna,
                                    onClickQuestion: function() {}
                                })
                            })
                        })
                    }, "qna-".concat(qna.question.questionPid));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationComponent/* default */.Z, {
                totalPage: viewModel.totalPage,
                queries: viewModel.queries,
                baseUrl: common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path,
                currentPage: Number(viewModel.queries.page),
                scroll: false,
                scrollRestoration: true
            })
        ]
    });
};
/* harmony default export */ var ui_RealtimeWebQna = (RealtimeWebQna);

// EXTERNAL MODULE: ./src/components/molecules/QuestionList/index.tsx + 1 modules
var QuestionList = __webpack_require__(37083);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ../../node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(84636);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
;// CONCATENATED MODULE: ./src/entities/qna/hook/useSearchQuestionsInfinite.ts








var useSearchQuestionsInfinite_DEFAULT_SIZE = 20;
var useSearchQuestionsInfinite_parseRealtimeQnaCardVo = function(data) {
    var items = data.searchQuestions.items.map(function(item) {
        var _title;
        return {
            answeredStatus: gql_schema/* QuestionAnsweredStatus.Answered */.G26.Answered,
            answer: null,
            answererCount: 0,
            answererProfileImageUrls: [],
            question: {
                accessibleType: item.accessibleType,
                content: item.content,
                createdAt: item.createdAt,
                isBlockedByMe: item.isBlockedByMe,
                isLikedByMe: false,
                isMine: false,
                likeCount: 0,
                questionPid: item.publicId,
                title: (_title = item.title) !== null && _title !== void 0 ? _title : "",
                attachments: item.attachments.map(function(attachment) {
                    return {
                        blindType: attachment.blindType,
                        questionAttachmentId: attachment.id
                    };
                }),
                category: {
                    name: item.category.name,
                    questionCategoryId: item.category.id,
                    iconImageUrl: item.category.iconImagePath
                },
                tags: item.tags,
                user: {
                    name: item.userMaskedName,
                    userId: item.userId
                }
            },
            questionCreatedAt: (0,format/* absoluteDate */.xt)(item.createdAt),
            answerCreatedAt: null,
            answeredStatusText: ""
        };
    });
    return items;
};
var useSearchQuestionsInfinite_parseRealtimeQnaCardTotalCount = function(data) {
    return data.searchQuestions.totalCount;
};
var useSearchQuestionsInfinite = function(param) {
    var categoryIds = param.categoryIds, _page = param.page, page = _page === void 0 ? 1 : _page, _size = param.size, size = _size === void 0 ? useSearchQuestionsInfinite_DEFAULT_SIZE : _size;
    var ref = useSearchQuestionsTotalCountQuery({
        request: {
            categoryIds: categoryIds,
            page: 1,
            size: size,
            sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
        }
    }, {
        staleTime: 5000,
        cacheTime: 5000,
        select: useSearchQuestionsInfinite_parseRealtimeQnaCardTotalCount
    }), tmp = ref.data, totalCount = tmp === void 0 ? 0 : tmp, isLoadingTotalCount = ref.isLoading;
    var totalPage = Math.ceil(totalCount / size);
    var ref1 = (0,useInfiniteQuery/* useInfiniteQuery */.N)(useSearchQuestionsItemsQuery.getKey({
        request: {
            categoryIds: categoryIds,
            page: 1,
            size: size,
            sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
        }
    }), function(param) {
        var pageParam = param.pageParam;
        var requestPage = pageParam !== null && pageParam !== void 0 ? pageParam : page;
        return useSearchQuestionsItemsQuery.fetcher({
            request: {
                categoryIds: categoryIds,
                page: requestPage,
                size: size,
                sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
            }
        })();
    }, {
        enabled: !!totalPage,
        getNextPageParam: function(_, pages) {
            if (pages.length < totalPage) {
                return pages.length + 1;
            }
            return undefined;
        }
    }), data = ref1.data, isLoading = ref1.isLoading, fetchNextPage = ref1.fetchNextPage, _hasNextPage = ref1.hasNextPage, hasNextPage = _hasNextPage === void 0 ? false : _hasNextPage;
    var qnaList = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        var qnas = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap(function(page) {
            return useSearchQuestionsInfinite_parseRealtimeQnaCardVo(page);
        })) !== null && ref1 !== void 0 ? ref1 : [];
        return uniqBy_default()(qnas, "question.questionPid");
    }, [
        data
    ]);
    return {
        totalPage: totalPage,
        questions: qnaList,
        isLoading: isLoadingTotalCount || isLoading,
        fetchNextPage: fetchNextPage,
        hasNextPage: hasNextPage
    };
};
/* harmony default export */ var hook_useSearchQuestionsInfinite = (useSearchQuestionsInfinite);
useSearchQuestionsInfinite.prefetchInfiniteQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, variables) {
        var _size, request;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = {
                        categoryIds: variables.categoryIds,
                        page: 1,
                        size: (_size = variables.size) !== null && _size !== void 0 ? _size : useSearchQuestionsInfinite_DEFAULT_SIZE,
                        sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
                    };
                    return [
                        4,
                        queryClient.prefetchInfiniteQuery(useSearchQuestionsItemsQuery.getKey({
                            request: request
                        }), function() {
                            return useSearchQuestionsItemsQuery.fetcher({
                                request: request
                            })();
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, variables) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/qna/realtime-webview/viewModels/useRealtimeWebViewQnaViewModel.ts



var useRealtimeWebViewQnaViewModel_DEFAULT_SIZE = 20;
var useRealtimeWebViewQnaViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var _query = router.query, _categoryId = _query.categoryId, categoryId = _categoryId === void 0 ? "" : _categoryId, _page = _query.page, page = _page === void 0 ? "1" : _page;
    var selectedCategoryIds = (0,react.useMemo)(function() {
        return categoryId ? [
            categoryId
        ] : [];
    }, [
        categoryId
    ]);
    var ref = hook_useSearchQuestionsInfinite({
        categoryIds: selectedCategoryIds,
        page: Number(page),
        size: useRealtimeWebViewQnaViewModel_DEFAULT_SIZE
    }), questions = ref.questions, isLoading = ref.isLoading, hasNextPage = ref.hasNextPage, fetchNextPage = ref.fetchNextPage, totalPage = ref.totalPage;
    return {
        queries: {
            categoryId: categoryId,
            page: page
        },
        questions: questions,
        isQnaListLoading: isLoading,
        totalPage: totalPage,
        hasNextPage: hasNextPage,
        fetchNextPage: fetchNextPage
    };
};
/* harmony default export */ var viewModels_useRealtimeWebViewQnaViewModel = (useRealtimeWebViewQnaViewModel);

;// CONCATENATED MODULE: ./src/features/qna/realtime-webview/ui/RealtimeWebviewQna.tsx




var RealtimeWebviewQna = function(props) {
    var viewModel = viewModels_useRealtimeWebViewQnaViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionList/* default */.Z, {
        questionCard: {
            data: viewModel.questions,
            isLoading: viewModel.isQnaListLoading,
            hasNextPage: viewModel.hasNextPage,
            fetchNextPage: viewModel.fetchNextPage
        },
        onClickQuestion: props.onClickQuestion,
        pageName: props.pageName
    });
};
/* harmony default export */ var ui_RealtimeWebviewQna = (RealtimeWebviewQna);

// EXTERNAL MODULE: ./src/hooks/Cuj/useAppInstallTopBanner.tsx
var useAppInstallTopBanner = __webpack_require__(72105);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Qna/QnaRealtimeTemplate/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 26px 24px 0 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 16px 24px 0px;\n\n  & > * {\n    ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 12px;\n  border-radius: 8px;\n  margin-left: 12px;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




















var QnaRealtimeTemplate = function(param) {
    var client = param.client, viewModel = param.viewModel;
    var ref, ref1, ref2, ref3;
    (0,useScreenFocus/* default */.Z)();
    var paidTerminationViewModel = (0,paid_question_termination/* usePaidQuestionTerminationViewModel */.o)(!client.isWebView || !client.isHeadlessBot);
    var topBannerViewModel = (0,useAppInstallTopBanner/* default */.Z)(client);
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    visible: true,
                    name: (ref4 = (ref = viewModel.selectedCategoriesBottomSheetTabItem) === null || ref === void 0 ? void 0 : ref.title) !== null && ref4 !== void 0 ? ref4 : "전체",
                    path: "".concat(common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path),
                    type: "qna",
                    urlParameter: ((ref1 = viewModel.selectedCategoriesBottomSheetTabItem) === null || ref1 === void 0 ? void 0 : ref1.value) ? "?categoryId=".concat((ref2 = viewModel.selectedCategoriesBottomSheetTabItem) === null || ref2 === void 0 ? void 0 : ref2.value) : ""
                })
            }),
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyAppHeader/* default */.Z, {
                    title: "실시간 의료상담"
                })
            }),
            client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB && topBannerViewModel.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                style: {
                    top: 60
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default */.Z, {
                    enableAnimation: true,
                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInstallTopBanner/* default */.Z, {
                        content: "web_top_bnr_list",
                        onClickClose: topBannerViewModel.hideBanner,
                        trackingInfo: {
                            campaign: "web_content_qna"
                        }
                    }),
                    bannerAdExchange: topBannerViewModel.bannerAdExchange,
                    onImpressionLog: topBannerViewModel.handleSendExposureLog,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default.Content */.Z.Content, {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default.BandCta */.Z.BandCta, {
                            onClose: topBannerViewModel.hideBanner
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                children: [
                                    client.clientType !== app/* ClientType.MOBILE_WEBVIEW */.B.MOBILE_WEBVIEW && "닥터나우 실시간 의료 상담 - ",
                                    (ref5 = (ref3 = viewModel.selectedCategoriesBottomSheetTabItem) === null || ref3 === void 0 ? void 0 : ref3.title) !== null && ref5 !== void 0 ? ref5 : "전체"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryButton, {
                                onClick: viewModel.onClickCategoriesBottomSheetTrigger,
                                children: [
                                    "증상/과목 선택",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsButtonDownMin/* default */.Z, {
                                        size: 12
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AiNotificationBanner/* default */.Z, {}),
                    client.isWebView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_RealtimeWebviewQna, {
                        onClickQuestion: viewModel.onClickQuestion,
                        pageName: viewModel.pageName
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_RealtimeWebQna, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaStickyWriteButton/* default */.Z, {
                        buttonText: viewModel.bottomButtonText,
                        pageName: viewModel.pageName,
                        onClickButton: viewModel.onClickStickButton
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBottomSheet/* default */.Z, {
                        isVisible: viewModel.showCategoriesBottomSheet,
                        toggleBottomSheet: viewModel.toggleCategoriesBottomSheet,
                        onClickCategoryItem: viewModel.onClickCategoriesBottomSheetTabListItem,
                        categoryGroup: viewModel.categoryGroup,
                        selectedTab: viewModel.selectedTab,
                        onClickCategoriesBottomSheetTab: viewModel.onClickCategoriesBottomSheetTab,
                        getSelectedTabItemList: viewModel.getSelectedTabItemList
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaidQuestionTerminationNoticeModal/* default */.Z, {
                        terminationDate: paidTerminationViewModel.terminationDate,
                        open: paidTerminationViewModel.isBottomSheetOpen,
                        onOpenChange: paidTerminationViewModel.handleBottomSheet
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Qna_QnaRealtimeTemplate = (QnaRealtimeTemplate);
var BreadCrumbsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b801b9c-0"
})(_templateObject());
var CategoryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b801b9c-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI22SB, ";\n    color: ").concat(theme.color.gray900, ";\n  ");
});
var CategoryButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-8b801b9c-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray600, ";\n    background: ").concat(theme.color.gray50, ";\n    \n    &: hover {\n      background: ").concat(theme.color.gray100, ";\n    }\n    &: active {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});

// EXTERNAL MODULE: ./src/hooks/Cuj/useAppDownloadCujModal.tsx + 1 modules
var useAppDownloadCujModal = __webpack_require__(6191);
// EXTERNAL MODULE: ./src/hooks/qna/useGetQnaCategoryGroup.ts
var useGetQnaCategoryGroup = __webpack_require__(62139);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ./src/types/qna.ts
var qna = __webpack_require__(18457);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/hooks/qna/list/useQnaRealtimeViewModel.ts












var BOTTOME_BUTTON_TEXT = "실시간 의료상담 물어보기";
var useQnaRealtimeViewModel = function() {
    var ref = (0,useCustomRouter/* default */.Z)(), router = ref.router, moveToPage = ref.moveToPage;
    var _query = router.query, _page = _query.page, page = _page === void 0 ? "1" : _page, _categoryId = _query.categoryId, categoryId = _categoryId === void 0 ? "" : _categoryId;
    var navigate = (0,useNavigate/* default */.Z)();
    var pageName = (0,logger/* getPageName */.j0)(router);
    var ref1 = (0,react.useState)(false), showCategoriesBottomSheet = ref1[0], setShowCategoriesBottomSheet = ref1[1];
    var ref2 = (0,react.useState)(qna/* QnaCategoryType.TREATMENT */.Q0.TREATMENT), selectedTab = ref2[0], setSelectedTab = ref2[1];
    var ref3 = (0,react.useState)(), selectedCategoriesBottomSheetTabItem = ref3[0], setSelectedCategoriesBottomSheetTabItem = ref3[1];
    var categoryGroup = (0,useGetQnaCategoryGroup/* default */.Z)().categoryGroup;
    // 카테고리 Bottom Sheet on/off
    var toggleCategoriesBottomSheet = function() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        setShowCategoriesBottomSheet(value);
    };
    // 카테고리 Bottom Sheet on
    var onClickCategoriesBottomSheetTrigger = function() {
        (0,logger/* communityLogger */.S4)({
            eventName: "filter_categories_click",
            pageName: pageName
        });
        toggleCategoriesBottomSheet();
    };
    // 카테고리 Bottom Sheet Tab Click
    var onClickCategoriesBottomSheetTab = function(tab) {
        setSelectedTab(tab.value);
    };
    // 카테고리 Bottom Sheet Tab Item Click
    var onClickCategoriesBottomSheetTabListItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                (0,logger/* communityLogger */.S4)({
                    eventName: "category_item_click",
                    pageName: pageName,
                    payload: {
                        categoryId: item.value
                    }
                });
                toggleCategoriesBottomSheet(false);
                setSelectedCategoriesBottomSheetTabItem(item);
                router.replace({
                    pathname: common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path,
                    query: {
                        categoryId: item.value,
                        page: "1"
                    }
                }, undefined, {
                    shallow: true
                });
                return [
                    2
                ];
            });
        });
        return function onClickCategoriesBottomSheetTabListItem(item) {
            return _ref.apply(this, arguments);
        };
    }();
    // 질문 클릭 -> 상세페이지 이동
    var onClickQuestion = function(param) {
        var questionId = param.questionId, sectionName = param.sectionName;
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionId),
            mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
            params: {
                questionId: questionId
            }
        });
        (0,logger/* communityLogger */.S4)({
            eventName: "quick_answer_item_click",
            pageName: pageName,
            payload: {
                section_name: sectionName !== null && sectionName !== void 0 ? sectionName : "",
                questionId: questionId
            }
        });
    };
    // 하단 버튼 클릭
    var onClickStickButton = function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            navigate.navigateToQnaWrite();
            return;
        }
        airbridge/* default.setDynamicLink */.Z.setDynamicLink({
            campaign: "web_content_qna",
            content: "web_bottom_flt_list",
            term: BOTTOME_BUTTON_TEXT
        });
    };
    var getSelectedTabItemList = function() {
        if (!categoryGroup) return [];
        return categoryGroup.tabsList.filter(function(tab) {
            return tab.key === selectedTab;
        })[0].categories;
    };
    // 글로벌 앱 설치 모달 트래킹 정보 저장
    var setIsCujModalTrackingInfo = (0,useAppDownloadCujModal/* default */.Z)().setIsCujModalTrackingInfo;
    (0,react.useEffect)(function() {
        setIsCujModalTrackingInfo({
            campaignName: "web_content_qna",
            trackContent: "web_mid_mdl_list"
        });
    }, []);
    (0,react.useEffect)(function() {
        if (categoryGroup && categoryId) {
            var selectedCategory = categoryGroup.categories.filter(function(category) {
                return category.value === categoryId;
            })[0];
            setSelectedCategoriesBottomSheetTabItem(selectedCategory);
        }
    }, [
        categoryGroup,
        categoryId
    ]);
    (0,react.useEffect)(function() {
        if (!router.query.categoryId) {
            setSelectedCategoriesBottomSheetTabItem({});
        }
    }, [
        categoryId
    ]);
    return {
        queries: {
            categoryId: categoryId,
            page: page
        },
        onClickQuestion: onClickQuestion,
        pageName: pageName,
        showCategoriesBottomSheet: showCategoriesBottomSheet,
        selectedCategoriesBottomSheetTabItem: selectedCategoriesBottomSheetTabItem,
        toggleCategoriesBottomSheet: toggleCategoriesBottomSheet,
        onClickCategoriesBottomSheetTrigger: onClickCategoriesBottomSheetTrigger,
        onClickCategoriesBottomSheetTabListItem: onClickCategoriesBottomSheetTabListItem,
        categoryGroup: categoryGroup,
        selectedTab: selectedTab,
        onClickCategoriesBottomSheetTab: onClickCategoriesBottomSheetTab,
        getSelectedTabItemList: getSelectedTabItemList,
        onClickStickButton: onClickStickButton,
        bottomButtonText: BOTTOME_BUTTON_TEXT
    };
};
/* harmony default export */ var list_useQnaRealtimeViewModel = (useQnaRealtimeViewModel);

// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/pages/content/qna/realtime/index.tsx
// PageDescription: 실시간 의료 상담 리스트 페이지








var QnaRealtime = function(param) {
    var client = param.client;
    var viewModel = list_useQnaRealtimeViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "실시간 의료상담 - 닥터나우",
                description: "24시간 대기하고 있는 닥터나우 의료인들이 실시간으로 답변해 드려요.",
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path).concat((0,url/* addQueryString */.sC)(viewModel.queries)),
                openGraph: {
                    title: "실시간 의료상담 - 닥터나우",
                    description: "24시간 대기하고 있는 닥터나우 의료인들이 실시간으로 답변해 드려요.",
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path).concat((0,url/* addQueryString */.sC)(viewModel.queries)),
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-qna.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Qna_QnaRealtimeTemplate, {
                client: client,
                viewModel: viewModel
            })
        ]
    });
};
QnaRealtime.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var realtime = (QnaRealtime);


/***/ }),

/***/ 15951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ep": function() { return /* binding */ appInstallTopBannerState; },
/* harmony export */   "Ih": function() { return /* binding */ setAppDownloadCujModalState; },
/* harmony export */   "Ze": function() { return /* binding */ appDownloadCujModalState; },
/* harmony export */   "_l": function() { return /* binding */ getAppInstallTopBannerState; },
/* harmony export */   "dl": function() { return /* binding */ hideBanner; }
/* harmony export */ });
/* unused harmony exports CujTestDateState, getCujTestDateState, setCujTestDateState, setBannerState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80888);




var CujTestDateState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "testDate",
    default: [],
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("testCujDate")
    ]
});
var getCujTestDateState = function() {
    return getRecoil(CujTestDateState);
};
var setCujTestDateState = function(date) {
    setRecoil(CujTestDateState, date);
};
var appDownloadCujModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appDownloadCujModalState",
    default: {
        isShow: false
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appDownLoadCujModal")
    ]
});
var appInstallTopBannerState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appInstallTopBannerStateType",
    default: {
        isVisible: false,
        expirationTime: undefined
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appInstallTopBanner")
    ]
});
var setAppDownloadCujModalState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appDownloadCujModalState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var getAppInstallTopBannerState = function() {
    var state = (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .getRecoil */ .$l)(appInstallTopBannerState);
    if (state.expirationTime === undefined) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    if (state.expirationTime && new Date() > new Date(state.expirationTime)) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    return state;
};
// 배너 상태를 설정하는 함수
var setBannerState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appInstallTopBannerState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var hideBanner = function() {
    var expirationTime = new Date(new Date().getTime() + 30 * 60 * 1000).toISOString(); // 30분
    setBannerState({
        isVisible: false,
        expirationTime: expirationTime
    });
};


/***/ }),

/***/ 18457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q0": function() { return /* binding */ QnaCategoryType; },
/* harmony export */   "X9": function() { return /* binding */ NpsCompleteType; },
/* harmony export */   "bM": function() { return /* binding */ AnswererType; },
/* harmony export */   "kU": function() { return /* binding */ QnaAnswerWriteReviewStatus; }
/* harmony export */ });
/* unused harmony exports AnswerLikeType, ProfessionalFieldType, QnaWriteBottomSheetType */
var QnaCategoryType = {
    TREATMENT: "treatment",
    DEPARTMENT: "department"
};
var AnswerLikeType;
(function(AnswerLikeType) {
    AnswerLikeType["Dislike"] = "DISLIKE";
    AnswerLikeType["Like"] = "LIKE";
})(AnswerLikeType || (AnswerLikeType = {}));
var AnswererType;
(function(AnswererType) {
    AnswererType["Ai"] = "AI";
    AnswererType["Doctor"] = "DOCTOR";
    AnswererType["Nurse"] = "NURSE";
})(AnswererType || (AnswererType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["Department"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var NpsCompleteType;
(function(NpsCompleteType) {
    NpsCompleteType["Satisfied"] = "satisfied";
    NpsCompleteType["UnSatisfied"] = "unSatisfied";
})(NpsCompleteType || (NpsCompleteType = {}));
var QnaWriteBottomSheetType;
(function(QnaWriteBottomSheetType) {
    QnaWriteBottomSheetType["Default"] = "Default";
    QnaWriteBottomSheetType["Pregnant"] = "pregnant";
    QnaWriteBottomSheetType["Attachments"] = "attachments";
    QnaWriteBottomSheetType["Reject"] = "reject";
})(QnaWriteBottomSheetType || (QnaWriteBottomSheetType = {}));
var QnaAnswerWriteReviewStatus;
(function(QnaAnswerWriteReviewStatus) {
    QnaAnswerWriteReviewStatus["RatingReview"] = "RATING_REVIEW";
    QnaAnswerWriteReviewStatus["SatisfactionReview"] = "SATISFACTION_REVIEW";
    QnaAnswerWriteReviewStatus["CompleteReview"] = "COMPLETE_REVIEW";
})(QnaAnswerWriteReviewStatus || (QnaAnswerWriteReviewStatus = {}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3063,9097,1498,8023,8286,2402,2271,5615,5666,4611,5180,1822,175,1743,4365,9535,5243,8652,6342,7638,9774,2888,179], function() { return __webpack_exec__(14524); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);